import "./OutputDisplay.css";


function OutputDisplay(props){

    return (
        <div className="output-container">
            <div className="output-div">
                <pre>{props.text}</pre>
            </div>
        </div>
    );
}

export default OutputDisplay;